export default {
      id: "ic_right-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_right",
      toString: function () {
        return this.url;
      }
    }